import { PersonalItemBaseDirective } from '$core/base/_personal-item.component';
import { AddressesService } from '$core/services/addresses.service';
import { AuthenticationService } from '$core/services/auth.service';
import { SwalService } from '$core/shell/swal/swal.service';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BLANK_STATUS_MAP } from '../../blanks.metadata';
import * as dayjs from 'dayjs';

@Component({
  selector: 'app-blank-item',
  templateUrl: './blank-item.component.html',
  styleUrls: ['./blank-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BlankItemComponent extends PersonalItemBaseDirective<any> {
  public readonly BLANK_STATUS_MAP = BLANK_STATUS_MAP;
  public readonly dayjs = dayjs;
  @Output() public selected = new EventEmitter();

  constructor(
    public authService: AuthenticationService,
    protected requestService: AddressesService,
    protected modalService: BsModalService,
    protected swalService: SwalService,
    protected translates: TranslateService
  ) {
    super(authService, requestService, modalService, swalService, translates);
  }

  public onSelect(): void {
    this.selected.emit();
  }
}
